import React from 'react';
import styled from 'styled-components';
import {useIntl} from 'react-intl';
import {Icon} from '@forecast-it/design-system';
import {C, F} from './versionsStyles';

const Mark = styled.span`
	display: inline-flex;
	align-items: center;
	gap: 5px;
	margin-left: 4px;
	color: ${C.success};
	white-space: nowrap;
	${F.detail}
`;

const Dot = styled.span`
	width: 7px;
	height: 7px;
	border-radius: 999px;
	background: ${C.success};
`;

/** Hidden on screen but read by screen readers, for text an element points at with `aria-describedby`. */
export const VisuallyHidden = styled.span`
	position: absolute;
	width: 1px;
	height: 1px;
	margin: -1px;
	padding: 0;
	overflow: hidden;
	clip: rect(0, 0, 0, 0);
	white-space: nowrap;
	border: 0;
`;

/**
 * The green "Active" mark beside the active version's name: a dot and "Active", or a lock and the quoted wording while
 * the active version is locked by a quote. It is plain text and never takes focus.
 */
export const ActiveMark = ({locked}: {locked: boolean}) => {
	const {formatMessage} = useIntl();
	return (
		<Mark data-cy="baseline-version-active">
			{locked ? <Icon icon="lockClosed" size="s" /> : <Dot />}
			{formatMessage({id: locked ? 'baseline.versions.active_quoted' : 'baseline.versions.active'})}
		</Mark>
	);
};

/** The tooltip that explains what the active version is used for. */
export const useActiveTip = (quotesEnabled: boolean) =>
	useIntl().formatMessage({
		id: quotesEnabled ? 'baseline.versions.active_tooltip' : 'baseline.versions.active_tooltip_no_quotes',
	});
